import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export interface IPropertyDetailContact {
  id: number;
  picture: string;
  name: string;
  phone: string;
  email: string;
  agencyName: string;
  agencyId: number;
}

export const prepareDetailPropertyAgents = (
  data: IPropertyDetailsResponse
): IPropertyDetailContact[] => {
  return (
    (data?.agents?.map(agent => ({
      id: agent.id,
      name: agent.name,
      phone: agent.mobile ?? agent.phone,
      email: agent.email,
      picture: agent.picture,
      agencyName: agent.agency_name,
      agencyId: agent.agency_id
    })) as IPropertyDetailContact[]) || []
  );
};
